import { render, staticRenderFns } from "./TaxonomyProductDataTableRow.vue?vue&type=template&id=7bfeb3ed&"
import script from "./TaxonomyProductDataTableRow.vue?vue&type=script&lang=js&"
export * from "./TaxonomyProductDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports